import { render } from "./ResolutionSelector.vue?vue&type=template&id=0f10bb60&scoped=true&ts=true"
import script from "./ResolutionSelector.vue?vue&type=script&lang=ts"
export * from "./ResolutionSelector.vue?vue&type=script&lang=ts"

import "./ResolutionSelector.vue?vue&type=style&index=0&id=0f10bb60&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f10bb60"]])

export default __exports__